var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "getting-discount" },
    [
      _c("progressbar", { attrs: { progressbar: _vm.data.progressbar } }),
      _c("h1", [_vm._v(_vm._s(_vm.trans("getting_discount_title")))]),
      !_vm.loggedIn && _vm.useMyBaumitUser
        ? _c("div", { staticClass: "row white-background" }, [
            _c("div", { staticClass: "col-lg-1 col-1" }),
            _c(
              "div",
              { staticClass: "col-lg-10 col-10 pt-5 pb-5" },
              [
                _c("h3", { staticClass: "mt-5" }, [
                  _vm._v(_vm._s(_vm.trans("getting_discount_login")))
                ]),
                _c(
                  "button",
                  { staticClass: "button type-2 mb-5 mt-5 calc-login" },
                  [_vm._v(_vm._s(_vm.trans("button_sign_in")))]
                ),
                _c("p", { staticClass: "bodytext mb-5" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.trans("getting_discount_dont_have")) +
                      "\n        "
                  ),
                  _c("br"),
                  _c("a", { staticClass: "button-style calc-reg" }, [
                    _vm._v(_vm._s(_vm.trans("button_register_now")))
                  ])
                ]),
                _c("loginpopup", { on: { login: _vm.onLogin } }),
                _c("regpopup", {
                  attrs: { targetGroups: _vm.targetGroups },
                  on: { registered: _vm.onRegistered }
                })
              ],
              1
            ),
            _c("div", { staticClass: "col-lg-1 col-1" })
          ])
        : _c("div", { staticClass: "white-background mt-5" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-lg-1 col-1" }),
              _c("div", { staticClass: "col-lg-10 col-10 pt-5 mobil-pb-5" }, [
                _c("h3", { staticClass: "mt-5" }, [
                  _vm._v(_vm._s(_vm.trans("getting_discount_describe_title")))
                ])
              ]),
              _c("div", { staticClass: "col-lg-1 col-1" })
            ]),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-lg-1 col-1" }),
              _c("div", { staticClass: "col-lg-10 col-10 pt-5 mobil-pb-5" }, [
                !_vm.useMyBaumitUser
                  ? _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12 col-md-6" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.data.user_name,
                                expression: "data.user_name"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              name: "user_name",
                              placeholder: _vm.trans("form_name")
                            },
                            domProps: { value: _vm.data.user_name },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.data,
                                  "user_name",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ])
                      ]),
                      _c("div", { staticClass: "col-12 col-md-6" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.data.user_email,
                                expression: "data.user_email"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "email",
                              name: "user_email",
                              placeholder: _vm.trans("form_email")
                            },
                            domProps: { value: _vm.data.user_email },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.data,
                                  "user_email",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ])
                      ])
                    ])
                  : _vm._e(),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12 col-md-6" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.data.city,
                            expression: "data.city"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          name: "city",
                          placeholder: _vm.trans("city_town")
                        },
                        domProps: { value: _vm.data.city },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.data, "city", $event.target.value)
                          }
                        }
                      })
                    ])
                  ]),
                  _c("div", { staticClass: "col-12 col-md-6" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.data.phone,
                            expression: "data.phone"
                          },
                          {
                            name: "mask",
                            rawName: "v-mask",
                            value: ["################"],
                            expression: "['################']"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          name: "phone",
                          placeholder: _vm.trans("phone_number"),
                          autocomplete: "off"
                        },
                        domProps: { value: _vm.data.phone },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.data, "phone", $event.target.value)
                          }
                        }
                      })
                    ])
                  ])
                ]),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.data.description,
                            expression: "data.description"
                          }
                        ],
                        staticClass: "form-control textarea",
                        attrs: {
                          name: "description",
                          rows: "7",
                          placeholder: _vm.trans("project_description")
                        },
                        domProps: { value: _vm.data.description },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.data,
                              "description",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ])
                ])
              ]),
              _c("div", { staticClass: "col-lg-1 col-1" })
            ]),
            _vm.usePartners
              ? _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-1" }),
                  _c("div", { staticClass: "col-10" }, [
                    _c("h3", { staticClass: "mt-5 mb-5" }, [
                      _vm._v(
                        _vm._s(_vm.trans("getting_discount_please_celect"))
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "col-1" })
                ])
              : _vm._e(),
            _vm.usePartners
              ? _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c("partners-map", {
                        on: { selectedPertners: _vm.onSelectedPartners }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-lg-1 col-1" }),
              _c("div", { staticClass: "col-lg-10 col-10 pb-5" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12" }, [
                    !_vm.useMyBaumitUser
                      ? _c("div", { staticClass: "form-check mt-5" }, [
                          _c("label", { staticClass: "form-check-label" }, [
                            _c("span", {
                              staticClass: "mdi mdi-name",
                              attrs: { for: "privacyPolicy" }
                            }),
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.trans("getting_discount_privacy_policy")
                                ) +
                                "\n                "
                            ),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.data.privacyPolicy,
                                  expression: "data.privacyPolicy"
                                }
                              ],
                              staticClass: "form-check-input",
                              attrs: {
                                type: "checkbox",
                                id: "privacyPolicy",
                                name: "privacyPolicy"
                              },
                              domProps: {
                                checked: Array.isArray(_vm.data.privacyPolicy)
                                  ? _vm._i(_vm.data.privacyPolicy, null) > -1
                                  : _vm.data.privacyPolicy
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.data.privacyPolicy,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.data,
                                          "privacyPolicy",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.data,
                                          "privacyPolicy",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.data, "privacyPolicy", $$c)
                                  }
                                }
                              }
                            })
                          ])
                        ])
                      : _vm._e(),
                    !_vm.useMyBaumitUser
                      ? _c("div", { staticClass: "form-check mt-5" }, [
                          _c("label", { staticClass: "form-check-label" }, [
                            _c("span", {
                              staticClass: "mdi mdi-name",
                              attrs: { for: "termConditions" }
                            }),
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.trans("getting_discount_terms_conditions")
                                ) +
                                "\n                "
                            ),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.data.termConditions,
                                  expression: "data.termConditions"
                                }
                              ],
                              staticClass: "form-check-input",
                              attrs: {
                                type: "checkbox",
                                id: "termConditions",
                                name: "termConditions"
                              },
                              domProps: {
                                checked: Array.isArray(_vm.data.termConditions)
                                  ? _vm._i(_vm.data.termConditions, null) > -1
                                  : _vm.data.termConditions
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.data.termConditions,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.data,
                                          "termConditions",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.data,
                                          "termConditions",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.data, "termConditions", $$c)
                                  }
                                }
                              }
                            })
                          ])
                        ])
                      : _vm._e(),
                    !_vm.enabledNewsletter
                      ? _c("div", { staticClass: "form-check mt-5" }, [
                          _c("label", { staticClass: "form-check-label" }, [
                            _c("span", {
                              staticClass: "mdi mdi-name",
                              attrs: { for: "newsletter" }
                            }),
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.trans("getting_discount_newletter")
                                ) +
                                "\n                "
                            ),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.data.newsletter,
                                  expression: "data.newsletter"
                                }
                              ],
                              staticClass: "form-check-input",
                              attrs: {
                                type: "checkbox",
                                id: "newsletter",
                                name: "newsletter"
                              },
                              domProps: {
                                checked: Array.isArray(_vm.data.newsletter)
                                  ? _vm._i(_vm.data.newsletter, null) > -1
                                  : _vm.data.newsletter
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.data.newsletter,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.data,
                                          "newsletter",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.data,
                                          "newsletter",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.data, "newsletter", $$c)
                                  }
                                }
                              }
                            })
                          ])
                        ])
                      : _vm._e(),
                    _c("div", { staticClass: "form-group mt-5" }, [
                      _c(
                        "button",
                        {
                          staticClass: "button type-1 mb-3",
                          attrs: { id: "getting-discount" },
                          on: {
                            click: function($event) {
                              return _vm.gettingDiscounts()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.trans("button_gettingdiscount")))]
                      )
                    ])
                  ])
                ])
              ]),
              _c("div", { staticClass: "col-lg-1 co-1" })
            ])
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }